import { Link } from "react-router-dom";
import TagPill from "@/components/base/TagPill";

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  coverImage: string;
  date: string;
  readTime: string;
  views: number;
}

export default function ArticleCard({
  slug,
  title,
  category,
  excerpt,
  coverImage,
  date,
  readTime,
  views,
}: ArticleCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/articles/${slug}`} className="block h-48 w-full overflow-hidden">
        <img
          src={coverImage}
          alt={`${title}配图`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <TagPill variant="accent">{category}</TagPill>
        <h2 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/articles/${slug}`} className="transition-colors hover:text-primary-700">
            {title}
          </Link>
        </h2>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{excerpt}</p>
        <div className="mt-4 flex flex-wrap items-center gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span>{date}</span>
          <span className="h-3 w-px bg-background-300" />
          <span>{readTime}</span>
          <span className="h-3 w-px bg-background-300" />
          <span className="inline-flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-eye-line text-sm" />
            </span>
            {views.toLocaleString()}
          </span>
        </div>
      </div>
    </article>
  );
}